// import axios from 'axios';
import axios from '../../utils/axiosConfig';
import {
  SALESDOCUMENT_CREATE_REQUEST,
  SALESDOCUMENT_CREATE_SUCCESS,
  SALESDOCUMENT_CREATE_FAIL,
  SALESDOCUMENT_LIST_REQUEST,
  SALESDOCUMENT_LIST_SUCCESS,
  SALESDOCUMENT_LIST_FAIL,
  SALESDOCUMENT_DETAILS_REQUEST,
  SALESDOCUMENT_DETAILS_SUCCESS,
  SALESDOCUMENT_DETAILS_FAIL,
  SALESDOCUMENT_UPDATE_REQUEST,
  SALESDOCUMENT_UPDATE_SUCCESS,
  SALESDOCUMENT_UPDATE_FAIL,
  SALESDOCUMENT_DELETE_REQUEST,
  SALESDOCUMENT_DELETE_SUCCESS,
  SALESDOCUMENT_DELETE_FAIL,
  SALESDOCUMENT_DOWNLOAD_REQUEST,
  SALESDOCUMENT_DOWNLOAD_SUCCESS,
  SALESDOCUMENT_DOWNLOAD_FAIL,
} from '../constants/salesDocumentConstants';

// Normalize localized values to backend-expected enums
const normalizeSalesDocumentPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return payload;

  const typeMap = {
    // Dutch → API
    factuur: 'invoice',
    'credit nota': 'credit',
    creditnota: 'credit',
    'provisie nota': 'provision note',
  };

  const statusMap = {
    // Dutch → API
    concept: 'draft',
    onbetaald: 'unpaid',
    'gedeeltelijk betaald': 'partially paid',
    betaald: 'paid',
  };

  const normalized = { ...payload };

  if (normalized.type && typeof normalized.type === 'string') {
    const key = normalized.type.toLowerCase();
    normalized.type = typeMap[key] || normalized.type;
  }

  if (normalized.status && typeof normalized.status === 'string') {
    const key = normalized.status.toLowerCase();
    normalized.status = statusMap[key] || normalized.status;
  }

  // Ensure required rateType exists; default reasonably to 'hourly' if omitted
  if (!normalized.rateType) {
    normalized.rateType = 'hourly';
  }

  return normalized;
};

export const createSalesDocument = (data) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_CREATE_REQUEST });
    const normalized = normalizeSalesDocumentPayload(data);
    const res = await axios.post('/api/salesDocuments', normalized);
    dispatch({ type: SALESDOCUMENT_CREATE_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_CREATE_FAIL, payload: error.message });
    throw error;
  }
};

export const downloadSalesDocument = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_DOWNLOAD_REQUEST });
    const res = await axios.get(`/api/salesDocuments/${id}/download`);
    dispatch({ type: SALESDOCUMENT_DOWNLOAD_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_DOWNLOAD_FAIL, payload: error.message });
  }
};

export const getSalesDocuments = () => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_LIST_REQUEST });
    const res = await axios.get('/api/salesDocuments');
    dispatch({ type: SALESDOCUMENT_LIST_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_LIST_FAIL, payload: error.message });
  }
};

export const getSalesDocumentsByCaseId = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_LIST_REQUEST });
    const res = await axios.get(`/api/salesDocuments/case/${id}`);
    dispatch({ type: SALESDOCUMENT_LIST_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_LIST_FAIL, payload: error.message });
  }
};

export const getSalesDocument = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_DETAILS_REQUEST });
    const res = await axios.get(`/api/salesDocuments/${id}`);
    dispatch({ type: SALESDOCUMENT_DETAILS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_DETAILS_FAIL, payload: error.message });
  }
};

export const updateSalesDocument = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_UPDATE_REQUEST });
    const normalized = normalizeSalesDocumentPayload(data);
    console.log('Updating sales document with Data:', normalized);
    const res = await axios.put(`/api/salesDocuments/${id}`, normalized);
    dispatch({ type: SALESDOCUMENT_UPDATE_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_UPDATE_FAIL, payload: error.message });
  }
};

export const deleteSalesDocument = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALESDOCUMENT_DELETE_REQUEST });
    await axios.delete(`/api/salesDocuments/${id}`);
    dispatch({ type: SALESDOCUMENT_DELETE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: SALESDOCUMENT_DELETE_FAIL, payload: error.message });
  }
};